<template>
  <div class="bg-white rounded p-6 lg:p-16 carousel">
    <ClientOnly>
      <Carousel
        v-if="guides"
        :items-to-show="1"
        :items-to-scroll="1"
        :wrapAround="true"
        @slide-start="handlePageChange"
      >
        <Slide
          v-for="(guide, index) in guides"
          :key="guide.id"
          :aria-hidden="currentSlide !== index"
          :tabindex="currentSlide !== index ? -1 : 0"
          class=""
        >
          <div :class="containerClass">
            <div class="w-full mb-4">
              <img
                v-if="guide.featured_image"
                :src="`${imageLocation}${guide.featured_image}`"
                class="block mx-auto"
                :style="{ maxHeight: '350px' }"
                :alt="guide.title"
                loading="lazy"
              />
            </div>

            <div
              class="w-full"
              v-if="currentSlide === index"
              :class="contentClass"
            >
              <h2 class="mb-2" v-text="guide.title" />
              <div v-html="guide.excerpt" />
              <p>
                <NuxtLink :to="guide.url" class="button">Learn more</NuxtLink>
              </p>
            </div>
          </div>
        </Slide>
        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </ClientOnly>
  </div>
</template>


<script setup lang="ts">
import { ref, computed } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import { useNuxtApp } from "#app";

// Props
const props = defineProps({
  guides: Array,
  vertical: Boolean,
});

// Reactive state
const { $config } = useNuxtApp();
const imageLocation = ref($config.public.sgCmsImage);
const currentSlide = ref(0);

// Computed properties
const containerClass = computed(() => {
  return props.vertical
    ? "flex flex-col items-center"
    : "grid grid-cols-1 md:grid-cols-2 gap-8 items-center pr-4";
});

const contentClass = computed(() => {
  return props.vertical ? "px-12" : "text-center";
});

// Methods
const handlePageChange = (slideStartEvent) => {
  currentSlide.value = slideStartEvent.slidingToIndex;
};

const strippedContent = (string) => {
  return string.replace(/<\/?[^>]+>/gi, " ");
};
</script>

